import { render, staticRenderFns } from "./CampaignPageSend.vue?vue&type=template&id=7aee8490&scoped=true"
import script from "./CampaignPageSend.vue?vue&type=script&lang=js"
export * from "./CampaignPageSend.vue?vue&type=script&lang=js"
import style0 from "./CampaignPageSend.vue?vue&type=style&index=0&id=7aee8490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aee8490",
  null
  
)

export default component.exports